import { useEffect,useMemo } from "react";
import useProfileStore, {useUserLastLoggedInStore} from "./UserProfileStore";
import moment from "moment";
import { useUpdateUserLastLogin } from "./useUserProfileQueries";

export interface IAMStore {
  id: string;
  name: string;
  defaultStore: boolean;
}

export const LoginEventListener = () => {

  const { mutate } = useUpdateUserLastLogin();

  const { oktaUserProfile, unifyUserProfile, iamUserProfile, permissions , currentStoreId ,enterpriseId } =
    useProfileStore();

  const { setLoggedInDate  } = useUserLastLoggedInStore();

  const shouldUpdate = useMemo(() => {
    try{
      if (!oktaUserProfile?.lastLogin ) return false;

      const cleaned = unifyUserProfile?.lastLoggedIn
        .replace(/^[A-Za-z]+,\s*/, '')
        .replace(/\s+at\s+/g, ', ')
        .replace(/Coordinated Universal Time$/, 'UTC');
      
      const date1 = new Date(cleaned);
      const date2 = new Date(oktaUserProfile.lastLogin);

      // Guard against invalid date parsing too
      if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        return false; // or false, depending on how you want to treat unparseable dates
      }

      return date1.toISOString() !== date2.toISOString();

    }catch(e){
      return true;
    }
  }, [oktaUserProfile, unifyUserProfile]);

  useEffect(() => {

    if (!shouldUpdate || !oktaUserProfile?.lastLogin || !iamUserProfile?.fullUser) return;

    const loggedInDate = moment.utc(oktaUserProfile.lastLogin);

    mutate({
      lastLogin: loggedInDate,
      enterpriseId,
      storeId: currentStoreId,
      permissions: permissions
    });
    setLoggedInDate(loggedInDate);
    //eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [shouldUpdate,oktaUserProfile, unifyUserProfile, iamUserProfile,permissions]);


  return null;
};
